

import React , { useEffect, useState, useRef } from 'react';
import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Translation, useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Auth.jsx"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import debounce from 'lodash/debounce';
// import jwt_decode from "jwt-decode";

import { jwtDecode } from 'jwt-decode';

const clientId = "385110396448-gslh1cuplef0ae1psp6a681s450qb2f0.apps.googleusercontent.com"

const RegisterLogIn= styled.div`
  display: flex; /* Enable flexbox */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  
  padding-top: 40px;
  padding-bottom: 100px;

   @media (max-width: 480px) {
  padding:80px 20px 100px ;
  width:100%;
  }
`;

const Container = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  place-self:center;
  overflow: hidden;
  width: 70%;
  max-width: 100%;
  min-height: 500px;

  @media (max-width: 480px) {
     width:100vw;
     box-shadow: 0 14px 28px rgba(0, 0, 0, 0.07), 0 10px 10px rgba(0, 0, 0, 0.05);
  }
`;

 const RegisterContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
  ${props => props.signinIn !== true ? `
    transform: translateX(100%);
    opacity: 1;
    z-index: 5;
  ` 
  : null}
  
`;

 const SignInContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  z-index: 2;
  ${props => (props.signinIn !== true ? `transform: translateX(100%);` : null)}
`;

 const Form = styled.form`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  text-align: center;
`;

 const Title = styled.h1`
  font-weight: bold;
  margin-bottom: 50px;
  font-size: 30px;

  @media (max-width: 480px) {
     font-size: 20px;
  }
  
`;

const Button = styled.button`
   border-radius: 20px;
   border: 1px solid #91abb3;
   background-color: #91abb3;
   color: #ffffff;
   font-size: 12px;
   font-weight: bold;
   margin-top: 20px;
   padding: 12px 45px;
   letter-spacing: 1px;
   text-transform: uppercase;
   transition: transform 80ms ease-in;
   &:active{
       transform: scale(0.95);
   }
   &:focus {
       outline: none;
   }

   &:hover {
        box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 60px;
        transition:  0.4s;
        cursor: pointer;
       background-color: #385963;
       border: 1px solid #385963;
      }

  @media (max-width: 480px) {
    padding: 10px 40px;
    font-size: 10px;
  }
`;


const GhostButton = styled(Button)`
  background-color: transparent;
  border-color: #ffffff;
`;

const Anchor = styled.a`
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
`;

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
  ${props =>
  props.signinIn !== true ? `transform: translateX(-100%);` : null}
`;

const Overlay = styled.div`
  background: #ff416c;
  background: -webkit-linear-gradient(to right, #ff4b2b, #385963);
  background: linear-gradient(to right, #3cc2a5 ,#1996bd);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  ${props => (props.signinIn !== true ? `transform: translateX(50%);` : null)}
`;

const OverlayPanel = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 40px;
    text-align: center;
    top: 0;
    height: 100%;
    width: 50%;
    transform: translateX(0);
    transition: transform 0.6s ease-in-out;
`;

const LeftOverLayComponent = styled(OverlayPanel)`
  transform: translateX(-20%);
  ${props => props.signinIn !== true ? `transform: translateX(0);` : null}
`;

const RightOverLayComponent = styled(OverlayPanel)`
    right: 0;
    transform: translateX(0);
    ${props => props.signinIn !== true ? `transform: translateX(20%);` : null}
`;

const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;

   @media (max-width: 480px) {
     font-size: 10px;
  }
`;

const BackLink = styled.a`
   font-size: 15px;
   margin-top: 50px;
   color: black;
   text-decoration: none;

   &:focus {
    outline: none;
   }

   &:hover {
       cursor: pointer;
       text-decoration: underline;
      }
`;

const ButtonFlex = styled.div`
 display:flex;
 flex-direction: column;
 gap:10px;
`;


const GoogleButtonWrapper = styled.div`
  display: inline-block;
  padding: 10px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 480px) {
    margin-top: 15px;
    padding: 8px;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const ModalContainer = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 16px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction:column;
  justify-content: space-around;
  margin-top: 1.5rem;
  gap: 1rem;
`;

const ConfirmButton = styled.button`
  background-color: #385963;
  color: white;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #2d4750;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 1rem;
  }
`;

const CancelButton = styled.button`
  background-color: #ccc;
  color: black;
  border: none;

  border-radius: 20px;
  cursor: pointer;

   font-size: 12px;
   font-weight: bold;
   margin-top: 20px;
   padding: 12px 45px;
   letter-spacing: 1px;
   text-transform: uppercase;
   transition: transform 80ms ease-in;
   &:active{
       transform: scale(0.95);
   }
   &:focus {
       outline: none;
   }

  &:hover {
  color:white;
   transition:  0.4s;
   cursor: pointer;
   background-color: #b3b3b3;
   box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 60px;
  }

   @media (max-width: 480px) {
     padding: 10px 40px;
     font-size: 10px;
   }
`;

const LinkContainer = styled.div`
   display:flex;
   gap:5px;
   justify-content:center;
   margin-top:50px;
   a{
   cursor: pointer;
   color:#2d4750;
    |:hover{
      text-decoration:underlined;
      
    }
   }

   @media (max-width: 768px) {
     flex-direction:column; 
     justify-content: center;
     align-items:center;
     text-align: center;
     font-size: 14px;
    }
`;


const RoleEnum = {
  RegisteredUser: 0,
  Provider: 1,
  Admin: 2,
  PreApprovedProvider: 3,
};


const SignIn = () => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const { i18n } = useTranslation();
const [signIn,toggle] = React.useState(true);
const [userType, setUserType] = useState("");
const [userUser, setUser] = useState({});
const[loggedIn, setLoggedIn] = useState(false);
const [googleError, setGoogleError] = useState("");
const googleSignInButtonRef = useRef(null);
const googleSignUpButtonRef = useRef(null);
const [isGoogleScriptLoaded, setIsGoogleScriptLoaded] = useState(false);
const navigate = useNavigate();
const [role,setRole] = useState(null);
const [showAdminModal, setShowAdminModal] = useState(false);
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const { user, login, logout } = useAuth();
const signedIn = sessionStorage.getItem("loggedIn");
const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    if (!window.google) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      // script.onload = initializeGoogleSignIn;
      script.onload = () => {
        setIsGoogleScriptLoaded(true);
    };
      document.body.appendChild(script);
    } else {
      // initializeGoogleSignIn();
      setIsGoogleScriptLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isGoogleScriptLoaded && (userType === "business" || userType === "visitor")) {
        initializeGoogleButtons();  
    }
  }, [isGoogleScriptLoaded, userType]);

  const initializeGoogleButtons = () => {
      if (googleSignInButtonRef.current) {
          googleSignInButtonRef.current.innerHTML = "";
          window.google.accounts.id.initialize({
              client_id: clientId,
              callback: handleGoogleSignUp
          });
          window.google.accounts.id.renderButton(
              googleSignInButtonRef.current,
              {
                  theme: "outline",
                  size: "large",
                  text: "signin_with",
              }
          );
      }

      if (googleSignUpButtonRef.current) {
          googleSignUpButtonRef.current.innerHTML = "";
          window.google.accounts.id.initialize({
              client_id:  clientId,
              callback: handleGoogleSignUp
          });
          window.google.accounts.id.renderButton(
              googleSignUpButtonRef.current,
              {
                  theme: "outline",
                  size: "large",
                  text: "signup_with",
              }
          );
      }
  };


  const handleUserType = (type) =>{
  setUserType(type);
  }; 

//       // public enum RoleEnum
//       // {
//       //     RegisteredUser,
//       //     Provider,
//       //     Admin,
//       //     PreApprovedProvider,
//       // }

  const handleGoogleSignUp = async (response) => {

 

    if (response.credential) {
        const token = response.credential;
      
        let role;
        if (userType === "visitor") {
          role = RoleEnum.RegisteredUser;
        } else if (userType === "business") {
          role = RoleEnum.PreApprovedProvider;
        } else if (userType === "admin") {
          role = RoleEnum.Admin;
        }
    
        const platform = 0;
        const requestBody = { token, role, platform };

        //otan kanw register thelei role
        try {
            const apiResponse = await fetch(
                `${BASE_URL}Auth/googleWebLogin`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            const data = await apiResponse.json();
            const tokenFromResponse = data.token; // The encoded token from the response

            if (!apiResponse.ok) {
                // USER DOES NOT EXIST
                if (data.message?.toLowerCase().includes("not") &&
                    data.message?.toLowerCase().includes("registered")) {
            
                    // OPEN REGISTER COMPONENT
                    toggle(false);  
                    setUserType("");  
            
                    return;
                }
            
                setGoogleError("Login failed. Please try again.");
                return;
            }
            
            if (apiResponse.ok && tokenFromResponse) {

                const decodedToken = jwtDecode(tokenFromResponse);

              const userRole = decodedToken.prn; // Extract the role from "prn"
      
              // Save token and role
              sessionStorage.setItem("token", encodeURIComponent(tokenFromResponse));
              sessionStorage.setItem("loggedIn", "true");
              sessionStorage.setItem("userRole", userRole);

              if(userRole === "Admin"){
                  navigate("/admin/dashboard"); 
              }else{
                 navigate("/"); 
              }

                // handleGoogleSignUp(tokenFromResponse);
                // navigate("/");  // Navigate to the home page or dashboard
                window.location.reload();  // Reload to reflect the new logged-in state

                toast.success("Login Successful!");
             
              
            } else {
                setGoogleError("Registration failed. Please try again.");
            }
        } catch (error) {
            console.error("Sign-Up error:", error);
            setGoogleError("Something went wrong during registration. Please try again.");
        }
    } else {
        setGoogleError("Something went wrong during registration. Please try again.");
    }
  };


  useEffect(() => {
    if (!loggedIn) {
        initializeGoogleButtons();
    }
  }, [loggedIn]); 

  const handleSignOut=()=>{
      logout();
      navigate("/");
      window.location.reload();
 
       // Ensure the Google sign-in button reference is available
    if (googleSignInButtonRef.current) {
      googleSignInButtonRef.current.innerHTML = "";
    }

    // Initialize the Google buttons after logging out
    initializeGoogleButtons();
  };

const [buttonSize, setButtonSize] = useState(window.innerWidth <= 480 ? 'small' : 'large');

useEffect(() => {
  const handleResize = () => {
    setButtonSize(window.innerWidth <= 480 ? 'small' : 'large');
  };

  const debouncedResize = debounce(handleResize, 100); // use lodash.debounce or custom
  window.addEventListener('resize', debouncedResize);
  handleResize();

  return () => {
    window.removeEventListener('resize', debouncedResize);
  };
}, []);



useEffect(() => {
  if (!isGoogleScriptLoaded || !userType) return;

  const container =
    userType === 'business' || userType === 'visitor'
      ? googleSignUpButtonRef.current
      : googleSignInButtonRef.current;

  if (!container) return;

  container.innerHTML = ''; // Reset

  window.google.accounts.id.initialize({
    client_id:  clientId,
    callback: handleGoogleSignUp,
  });

  window.google.accounts.id.renderButton(container, {
    theme: 'outline',
    size: buttonSize,
    text: userType ? (signIn ? i18n.t('signin_with') : i18n.t('signup_with')) : '',
    shape: 'pill',
  });
}, [isGoogleScriptLoaded, userType, buttonSize, signIn]);


  return(

  <>
   <RegisterLogIn data-aos="zoom-in-down">
      <Container>    
          <RegisterContainer signinIn={signIn}>
              <Form>
                  <Title>{i18n.t('createAccount')}</Title>
                  
                  {/* User type selection */}
                  {userType === "" && (
                    <div>
                      <p>{i18n.t('registerAs')}</p>
                      <ButtonFlex>
                        <Button value="visitor" onClick={() => handleUserType("visitor")}>
                          {i18n.t('visitor')}
                        </Button>
                        <Button value="business" onClick={() => handleUserType("business")}>
                          {i18n.t('business')}
                        </Button>
                      </ButtonFlex>
                    </div>
                  )}

                  {userType === "visitor" || userType === "business" ? (
                    <>
                      <div>
                        {signedIn ? (
                          <div>
                            {/* <p>You have signed in as:</p>
                            <img src={userUser.picture} alt="User Profile" />
                            <h3>{userUser.name}</h3> */}
                            <p>{i18n.t('alreadyLoggedIn')}</p>
                            <Button onClick={handleSignOut}>{i18n.t('signOut')}</Button>
                          </div>
                        ) : (
                          <GoogleButtonWrapper>
                            <div ref={googleSignUpButtonRef}></div>
                          </GoogleButtonWrapper>
                        )}
                      </div>
                      <BackLink onClick={() => {handleUserType("");}}>{i18n.t('back')}</BackLink>
                    </>
                  ) : (
                    <div>
                      <p style={{ color: '#385963' , marginTop:'50px', fontSize:'12px'}}>{i18n.t('selectUserType')}</p>
                    </div>
                  )}
               </Form>
          </RegisterContainer>

          <SignInContainer signinIn={signIn}>
                <Form >  
                  { signedIn ?
                    <div>
                      <Title>{i18n.t('signIn')}</Title>
                      <p>{i18n.t('alreadyLoggedIn')}</p>
                      <Button onClick={handleSignOut}>
                        {i18n.t('signOut')}
                      </Button>
                    </div>
                    :
                    <div> 
                      <Title>{i18n.t('signIn')}</Title>
                      <GoogleButtonWrapper>
                        <div ref={googleSignInButtonRef}></div>
                      </GoogleButtonWrapper>

                    {/* <LinkContainer onClick={() => setShowAdminModal(true)}>
                      <Link> {i18n.t('signInAsAdmin')}</Link>
                    </LinkContainer>        */}
                    </div>
                  }
                </Form>
          </SignInContainer>

          <OverlayContainer signinIn={signIn}>
            <Overlay signinIn={signIn}>
                <LeftOverLayComponent signinIn={signIn}>
                  <Title>{i18n.t('welcomeBack')}</Title>
                  <Paragraph>{i18n.t('signInDescription')}</Paragraph>
                  <GhostButton onClick={()=> {toggle(true); setUserType(""); }}>{i18n.t('signIn')}</GhostButton>
                </LeftOverLayComponent>

                <RightOverLayComponent  signinIn={signIn}>
                  <Title>{i18n.t('welcomeToOR')}</Title>
                  <Paragraph>{i18n.t('registerDescription')}</Paragraph>
                  <GhostButton onClick={()=> {toggle(false); setUserType(""); }}>{i18n.t('register')}</GhostButton>
                </RightOverLayComponent>
            </Overlay>
          </OverlayContainer>
      </Container>
    </RegisterLogIn>
   </>
  );
};

export default SignIn

